import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    overflow: 'hidden',
    overflowX: 'hidden',
    height: '100%',
    '&::-webkit-scrollbar': {
      width: 0,
    },
    fontFamily: 'Roboto'
  },
  nameDiv: {
    width: '50%',
    margin: 'auto',
    marginTop: '60px',
  },
}));

export { useStyles };
